import PropTypes from 'prop-types';
import React from 'react';

import Analytics from '@app/modules/analytics/index';

export default class Step extends React.PureComponent {
  componentDidMount() {
    this.trackAnalytics(this.props.analyticsEvent);
  }

  trackAnalytics = (analyticsEvent) => {
    if (!analyticsEvent) {
      return;
    }
    const { action, category, label } = analyticsEvent;
    Analytics.pushDataLayerEvent({
      action: action,
      category: category,
      label: label,
    });

    // Temporay mapping for different event naming between GA and Snowplow
    // @June 2019: Replace GA with Snowplow tracking once data anlaytist confirms the event count between them matches
    switch (label) {
      case 'upload-files':
        Analytics.trackStructEvent({
          category: 'transfer',
          action: 'show_upload_files',
        });
        break;

      case 'add-message':
        Analytics.trackStructEvent({
          category: 'transfer',
          action: 'show_add_message',
        });
        break;

      case 'select-type':
        Analytics.trackStructEvent({
          category: 'transfer',
          action: 'show_select_type',
        });
        break;

      default:
        break;
    }
  };

  render() {
    const { children } = this.props;
    return children;
  }
}

Step.propTypes = {
  analyticsEvent: PropTypes.shape({
    action: PropTypes.string,
    category: PropTypes.string,
    label: PropTypes.string,
  }),
  children: PropTypes.node,
  disabled: PropTypes.bool,
  prevButton: PropTypes.shape({
    text: PropTypes.string,
    onClick: PropTypes.func,
  }),
  nextButton: PropTypes.shape({
    text: PropTypes.string,
    onClick: PropTypes.func,
  }),
};
